import { combineReducers } from 'redux';
import listSurveysByUserId from './list-surveys-by-user-id';
import submitSurvey from './submit-survey';
export { listSurveysByUserId, submitSurvey };
export default combineReducers({
    listSurveysByUserId,
    submitSurvey,
});
